import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const AntiAdblockDomainsPage = () =>
  import('@/apps/adok/pages/anti-adblock-domains').then(
    (m) => m.AntiAdblockDomainsPage
  )

const antiAdblockDomainsRoutes: RouteRecordRaw[] = [
  {
    path: '/anti-adblock-domains',
    component: Layout,
    children: [
      {
        path: '',
        name: 'anti-adblock-domains',
        component: AntiAdblockDomainsPage,
        meta: {
          title: 'Anti adblock domains'
        }
      },
      {
        path: 'new',
        name: 'anti-adblock-domains-new',
        component: AntiAdblockDomainsPage,
        meta: {
          title: 'New anti adblock domain',
          hidden: true
        }
      },
      {
        path: ':domainId/verify',
        name: 'anti-adblock-domains-verify',
        component: AntiAdblockDomainsPage,
        props: true,
        meta: {
          title: 'Verify anti adblock domain',
          hidden: true
        }
      },
      {
        path: ':domainId/checks',
        name: 'anti-adblock-domains-checks',
        component: AntiAdblockDomainsPage,
        props: true,
        meta: {
          title: 'Safety checks',
          hidden: true
        }
      }
    ]
  }
]

export default antiAdblockDomainsRoutes
